module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hans/4/1-27b2b92d1c2444ee67235664cadeb5eb.jpg";